module.exports = __webpack_public_path__ + "img/regular_timeline.9d05c628.svg";